import { Expose, Type } from "class-transformer";
import type { UUID } from "crypto";
import type { DisabilityLaw104SeverityEnum } from "../../features/profile/constants/disability-law-104-severity.enum";
import type { MaritalStatusEnum } from "../../features/profile/constants/household/marital-status.enum";
import { Disability } from "../../legacy/services/persona/entities/disability/disability.entity";
import type { IDisability } from "../../legacy/services/persona/entities/disability/disability.entity.interface";
import { ProfileData } from "../../legacy/services/profile-data/entities/profile-data.entity";
import type { IProfileData } from "../../legacy/services/profile-data/entities/profile-data.entity.interface";
import type { GenderEnum } from "./constants/gender.enum";
import type { TaxCodeModeEnum } from "./constants/tax-code-mode.enum";
import type { IPersona } from "./persona.entity.interface";

export class Persona implements IPersona {
  @Expose()
  id!: UUID;

  @Expose()
  citizenId: number | null = null;

  @Expose()
  firstName?: string;

  @Expose()
  lastName?: string;

  @Expose()
  taxCode?: string;

  @Expose()
  birthDate?: string;

  @Expose()
  birthPlace?: string;

  @Expose()
  gender?: GenderEnum;

  @Expose()
  citizenship?: string[];

  @Expose()
  residencePermitType?: string;

  @Expose()
  registeredCountry?: string;

  @Expose()
  registeredMunicipality?: string;

  @Expose()
  registeredProvince?: string;

  @Expose()
  registeredRegion?: string;

  @Expose()
  registeredCountryAsCurrent?: boolean;

  @Expose()
  isRegisteredInAire?: boolean;

  @Expose()
  currentCountry?: string;

  @Expose()
  currentMunicipality?: string;

  @Expose()
  currentAddressType?: string;

  @Expose()
  @Type(() => Disability)
  disabilities!: IDisability[];

  @Expose()
  @Type(() => ProfileData)
  profileData?: IProfileData;

  @Expose()
  disability?: boolean;

  @Expose()
  disabilityLaw104?: boolean;

  @Expose()
  disabilityLaw104Severity?: DisabilityLaw104SeverityEnum;

  @Expose()
  maritalStatus?: MaritalStatusEnum;

  @Expose()
  taxCodeMode?: TaxCodeModeEnum | null;
}
